import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Alert } from 'src/app/global/types';
import { PolicyService } from './policy.service';
import { cloneDeep } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private alertsSource = new BehaviorSubject<Alert[]>([]);

  alertsObservable = this.alertsSource.asObservable();

  alerts: Alert[] = [];

  constructor(     
    private _policyService: PolicyService,
  ) { }

  /**
   * Display an alert banner a the top of the page.
   * Intended to be used for displaying error messages to the user,
   * such as when an API call fails. 
   * Will not display an alert if the user is not authorized to view the application.
   * @param alert 
   */
  addAlert(alert: Alert) {
    let isAuthorized = true;
      this._policyService.isAuthorized$.subscribe(authorized => {
      isAuthorized = authorized;
    });
    //Only add the alert if the user is authorized. If the user is not authorized, we don't want to show any alerts.
    if(isAuthorized){
      this.alerts.push(alert);
      this.alertsSource.next(this.alerts);
    }
  }

  removeAlert(id: number) {
    this.alerts = this.alerts.filter(a => a.id != id);
    this.alertsSource.next(this.alerts);
  }

  async alertOnError<T>(action: () => Promise<any>, message: string): Promise<T | undefined> {
    try {
      var result = await action();
      return result as T;
    }
    catch (e) {
      this.addAlert({
        message: message,
        id: Math.random() * 25
      });
    }

    return undefined;
  }
}
